// Call Sheet's share text (CLAUDE.md: Share is the primary action).
//
// The site, the game and the number, then the result line, then one row of
// squares, then the link. The row is one square per guess used: purple for the
// right one, white for a wrong guess or a skip — "⬜⬜🟪" is solved on the
// third, "⬜⬜⬜" a miss. It never says which wrong guesses were skips, and it
// never names a title: a share that listed them would spoil the puzzle.
//
// A win is `Solved in 2/3`; a miss is `Missed`, a word, because a copied line
// in somebody else's message has to say the outcome, and the squares under it
// already show the three guesses spent.
const SITE = 'cinemore.co.uk';
const RIGHT = '🟪';
const WRONG = '⬜';
const MAX = 3;

export function shareText(number: number, won: boolean, guessCount: number): string {
  const used = won ? guessCount : MAX;
  const row = WRONG.repeat(won ? used - 1 : used) + (won ? RIGHT : '');
  return [
    `Cinemore · Call Sheet #${number}`,
    won ? `Solved in ${guessCount}/${MAX}` : 'Missed',
    row,
    `${SITE}/call-sheet/${number}`
  ].join('\n');
}

export { copyToClipboard } from '../running-order/share.ts';
